import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-h-border-panel" }
const _hoisted_2 = { class: "p-h-border-panel__inner" }
const _hoisted_3 = {
  key: 0,
  class: "p-h-border-panel__header"
}
const _hoisted_4 = { class: "p-h-border-panel__heading" }
const _hoisted_5 = {
  key: 1,
  class: "p-h-border-panel__body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HSpecColumnList = _resolveComponent("HSpecColumnList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$slots.heading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _renderSlot(_ctx.$slots, "heading", {}, undefined, true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.body || _ctx.specListItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "body", {}, undefined, true),
            _createVNode(_component_HSpecColumnList, {
              "list-item": _ctx.specListItem,
              "column-size": "l"
            }, null, 8, ["list-item"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(`p-h-container--${_ctx.bodyMargin}`)
          }, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}